import { OrderEditRestrictionType } from "@order/enums/order-edit-restriction-type";

export class OrderEditRestriction {

	readonly canChangeCustomer: boolean;
	readonly canChangeProduct: boolean;
	readonly canChangeIssueDate: boolean;
	readonly canChangePlacement: boolean;
	readonly canChangeSize: boolean;
	readonly canChangePricing: boolean;
	readonly canChangeMaterialNumberPerOrderLine: boolean;
	readonly canChangeMaterialAgency: boolean;
	readonly canChangeCampaignDescription: boolean;
	readonly canReserve: boolean;
	readonly canConfirm: boolean;
	readonly canCancel: boolean;
	readonly canAddOrderLine: boolean;
	readonly canRemoveOrderLine: boolean;
	readonly canChangeOtherFields: boolean;
	readonly canSaveAsDraft: boolean;
	readonly canReservePerOrderLine: boolean;
	readonly canConfirmPerOrderLine: boolean;

	static create(restrictionType: OrderEditRestrictionType = OrderEditRestrictionType.None): OrderEditRestriction {
		return new OrderEditRestriction(restrictionType);
	}

	static createDefault(): OrderEditRestriction {
		return new OrderEditRestriction(OrderEditRestrictionType.None);
	}

	private constructor (orderStatus: OrderEditRestrictionType) {

		// please don't set any defaults here, so the compiler/IDE will always show any forgotten fields

		switch (orderStatus) {
			case OrderEditRestrictionType.Draft:
				this.canChangeCustomer = true;
				this.canChangeProduct = true;
				this.canChangeIssueDate = true;
				this.canChangePlacement = true;
				this.canChangeSize = true;
				this.canChangePricing = true;
				this.canChangeMaterialNumberPerOrderLine = true;
				this.canChangeMaterialAgency = true;
				this.canChangeCampaignDescription = true;
				this.canReserve = true;
				this.canConfirm = true;
				this.canCancel = true;
				this.canAddOrderLine = true;
				this.canRemoveOrderLine = true;
				this.canChangeOtherFields = true;
				this.canSaveAsDraft = true;
				this.canReservePerOrderLine = true;
				this.canConfirmPerOrderLine = true;
				break;
			case OrderEditRestrictionType.Reserved:
			case OrderEditRestrictionType.Confirmed:
				this.canChangeCustomer = false;
				this.canChangeProduct = true;
				this.canChangeIssueDate = true;
				this.canChangePlacement = true;
				this.canChangeSize = true;
				this.canChangePricing = true;
				this.canChangeMaterialNumberPerOrderLine = true;
				this.canChangeMaterialAgency = true;
				this.canChangeCampaignDescription = true;
				this.canReserve = true;
				this.canConfirm = true;
				this.canCancel = true;
				this.canAddOrderLine = true;
				this.canRemoveOrderLine = true;
				this.canChangeOtherFields = true;
				this.canSaveAsDraft = false;
				this.canReservePerOrderLine = true;
				this.canConfirmPerOrderLine = true;
				break;
			case OrderEditRestrictionType.PastBookingDeadline:
				this.canChangeCustomer = false;
				this.canChangeProduct = false;
				this.canChangeIssueDate = false;
				this.canChangePlacement = false;
				this.canChangeSize = false;
				this.canChangePricing = false;
				this.canChangeMaterialNumberPerOrderLine = true;
				this.canChangeMaterialAgency = true;
				this.canChangeCampaignDescription = true;
				this.canReserve = false;
				this.canConfirm = false;
				this.canCancel = false;
				this.canAddOrderLine = false;
				this.canRemoveOrderLine = false;
				this.canChangeOtherFields = true;
				this.canSaveAsDraft = false;
				this.canReservePerOrderLine = false;
				this.canConfirmPerOrderLine = false;
				break;
			case OrderEditRestrictionType.PastMaterialDeadline:
				this.canChangeCustomer = false;
				this.canChangeProduct = false;
				this.canChangeIssueDate = false;
				this.canChangePlacement = false;
				this.canChangeSize = false;
				this.canChangePricing = false;
				this.canChangeMaterialNumberPerOrderLine = false;
				this.canChangeMaterialAgency = false;
				this.canChangeCampaignDescription = true;
				this.canReserve = false;
				this.canConfirm = false;
				this.canCancel = false;
				this.canAddOrderLine = false;
				this.canRemoveOrderLine = false;
				this.canChangeOtherFields = true;
				this.canSaveAsDraft = false;
				this.canReservePerOrderLine = false;
				this.canConfirmPerOrderLine = false;
				break;
			case OrderEditRestrictionType.Invoiced:
			case OrderEditRestrictionType.Cancelled:
				this.canChangeCustomer = false;
				this.canChangeProduct = false;
				this.canChangeIssueDate = false;
				this.canChangePlacement = false;
				this.canChangeSize = false;
				this.canChangePricing = false;
				this.canChangeMaterialNumberPerOrderLine = false;
				this.canChangeMaterialAgency = false;
				this.canChangeCampaignDescription = true;
				this.canReserve = false;
				this.canConfirm = false;
				this.canCancel = false;
				this.canAddOrderLine = false;
				this.canRemoveOrderLine = false;
				this.canChangeOtherFields = false;
				this.canSaveAsDraft = false;
				this.canReservePerOrderLine = false;
				this.canConfirmPerOrderLine = false;
				break;
			default:
				this.canChangeCustomer = false;
				this.canChangeProduct = false;
				this.canChangeIssueDate = false;
				this.canChangePlacement = false;
				this.canChangeSize = false;
				this.canChangePricing = false;
				this.canChangeMaterialNumberPerOrderLine = false;
				this.canChangeMaterialAgency = false;
				this.canChangeCampaignDescription = false;
				this.canReserve = false;
				this.canConfirm = false;
				this.canCancel = false;
				this.canAddOrderLine = false;
				this.canRemoveOrderLine = false;
				this.canChangeOtherFields = false;
				this.canSaveAsDraft = false;
				this.canReservePerOrderLine = false;
				this.canConfirmPerOrderLine = false;
				break;
		}
	}
}
